var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ct-mapbox-map"},[_c('div',{ref:"mapRef",staticClass:"ct-mapbox-map__container",attrs:{"id":_vm.id}}),_vm._v(" "),(_vm.loaded)?_c('div',{staticClass:"ct-mapbox-map__slot"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }